import { OpenActionSheetProps } from '@/hooks/interfaces/actionSheet';
import { ActionCableProvider } from '@hooks/actionCable';
import Notifications from '@/screens/utils/ActionSheets/Notifications';
import React from 'react';

export const actionSheetNotificationsConfig: OpenActionSheetProps = {
  children: (
    <ActionCableProvider>
      <Notifications />
    </ActionCableProvider>
  ),
  title: 'Notificações',
  key: 'notifications',
  side: 'left',
  destroyOnClose: true,
};
